import React, { useState } from 'react';
import { MATURITY_LEVELS } from '../../constants/assessmentTypes';
import { ChevronDown, ChevronUp } from 'lucide-react';

const MaturityLevelsPanel = ({ maturityLevelInfo, onSelectLevel }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-md mb-6 overflow-hidden">
      {/* Header with toggle */}
      <div 
        className="flex justify-between items-center p-4 cursor-pointer hover:bg-blue-100 transition-colors duration-150"
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <div className="flex items-center">
          <div className="flex-shrink-0 w-8 h-8 bg-blue-700 rounded-full flex items-center justify-center mr-3">
            <span className="text-white font-bold">E8</span>
          </div>
          <h2 className="text-lg font-semibold text-blue-800">Maturity Levels Framework</h2>
        </div>
        <div className="flex items-center">
          <span className="text-sm text-blue-600 mr-2">
            {isCollapsed ? 'Show Details' : 'Hide Details'}
          </span>
          {isCollapsed ? (
            <ChevronDown className="w-5 h-5 text-blue-600" />
          ) : (
            <ChevronUp className="w-5 h-5 text-blue-600" />
          )}
        </div>
      </div>
      
      {/* Content - only shown when not collapsed */}
      {!isCollapsed && (
        <div className="p-4 pt-0 border-t border-blue-200">
          <div className="flex justify-end space-x-2 mb-3 mt-3">
            {Object.entries(maturityLevelInfo).map(([mlKey, info]) => (
              <button
                key={mlKey}
                className={`px-3 py-1 text-sm font-medium rounded-md ${
                  mlKey === MATURITY_LEVELS.ML1 ? 'bg-blue-100 text-blue-700 hover:bg-blue-200' : 
                  mlKey === MATURITY_LEVELS.ML2 ? 'bg-purple-100 text-purple-700 hover:bg-purple-200' :
                  'bg-green-100 text-green-700 hover:bg-green-200'
                }`}
                onClick={() => onSelectLevel(mlKey)}
              >
                Maturity Level {mlKey.substring(2)}
              </button>
            ))}
          </div>
          <p className="text-sm text-gray-600">
            The Essential Eight framework uses three maturity levels to describe the cybersecurity posture and 
            capabilities required to counter various threat actors. Click on a maturity level button to learn more 
            about the specific threat actors and capabilities addressed at each level.
          </p>
        </div>
      )}
    </div>
  );
};

export default MaturityLevelsPanel; 